import { appstr } from "../utils/appstr";
import { appstrp } from "../utils/appstrp";
import { DoUploadFile } from "../utils/DoUploadFile";
import { DoUploadStatus } from "../utils/DoUploadStatus";
import { removeFilesByName } from "../utils/removeFilesByName";
import { enumUploadCode } from "../constants";
import { Globals } from "./Globals";
import { QAlert } from "./QAlert";
import { QFileExists } from "./QFileExists";
import { QFileExistsAlert } from "./QFileExistsAlert.js";
import { QOneUse } from "./QOneUse";
import { getsessioninfo } from "../utils/getsessioninfo";

export class QUploadMgr {
  constructor() {
    this.fiFrame = null;
    //	this.fForm = null;
    this.fInput = null;
    this.fCallBack = null;
    this.fWSMgr = null;
    this.fAutoOverwrite = false;
  }

  SetAutoOverwrite(overwrite) {
    this.fAutoOverwrite = overwrite;
  }

  CreateTargetIFrame() {
    var t = document.createElement("iframe");
    this.fiFrame = t;
    var b = document.getElementById("appbody") || document.body;
    t.setAttribute("style", "visibility:hidden;display:none");
    t.setAttribute("id", "uploadiframe");
    t.setAttribute("name", "uploadiframe");
    b.appendChild(t);
    t.onload = DoUploadStatus;
  }

  CreateForm() {
    // html input element with type file. This is the browser file picker that spawns when doing an upload
    // refer to https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
    var f = document.createElement("form");
    //	this.fForm = f;
    var b = document.getElementById("appbody") || document.body;

    f.setAttribute("style", "visibility:hidden;display:none");
    f.setAttribute("id", "uploadform");
    f.setAttribute("name", "uploadform");
    f.setAttribute("enctype", "multipart/form-data");
    f.setAttribute("action", "/ServerSide/quploadfile");
    f.setAttribute("method", "post");
    f.setAttribute("target", "uploadiframe");

    var i = document.createElement("input");
    this.fInput = i;
    i.setAttribute("id", "selectfile");
    i.onchange = DoUploadFile;
    i.setAttribute("type", "file");
    i.setAttribute("name", "files");
    i["uploadmgr"] = this;
    f.appendChild(i);
    this.AllowMultipleFileUploads(false);

    var org = document.createElement("input");
    org.setAttribute("name", "curorg");
    org.setAttribute("id", "curorg");
    f.appendChild(org);

    var user = document.createElement("input");
    user.setAttribute("name", "curuser");
    user.setAttribute("id", "curuser");
    f.appendChild(user);

    var dir = document.createElement("input");
    dir.setAttribute("name", "curdir");
    dir.setAttribute("id", "curdir");
    f.appendChild(dir);

    var sk = document.createElement("input");
    sk.setAttribute("name", "sk");
    sk.setAttribute("id", "sk");
    f.appendChild(sk);

    var params = document.createElement("input");
    params.setAttribute("name", "params");
    params.setAttribute("id", "params");
    f.appendChild(params);

    b.appendChild(f);
  }

  InitUploadMgr(
    wsMgr //callback
  ) {
    this.fWSMgr = wsMgr;
    this.CreateTargetIFrame();
    this.CreateForm();
  }

  SetCallBack(callback, excelOnly, customType) {
    this.fCallBack = callback;
    this.fiFrame["callback"] = callback;
    this.fInput["callback"] = callback;
    this.fInput["excelonly"] = excelOnly;
    this.fInput["customtype"] = customType;
    this.fAutoOverwrite = false;
  }

  DoUpload(curOrg, curUser, curDir, restrictArray, dropTarget = null) {
    //console.log("DoUpload:", this.fInput.value);
    if (dropTarget != null) {
      //var i = document.getElementById("selectfile");
      this.fInput["dropTarget"] = dropTarget;
    }
    var restrict = restrictArray != null ? restrictArray : [];
    this.fInput.value = "";
    this.fInput["active"] = false;
    this.fInput["curorg"] = curOrg;
    this.fInput["curuser"] = curUser;
    this.fInput["curdir"] = curDir;
    this.fInput["restrict"] = restrict;
    this.AllowMultipleFileUploads(this.fWSMgr.fFileMgr != null);

    // direct user towards desired file types. 'accept' attribute attempts to restrict the files shown and files allowed to the types that are specified. comma separated list of '.<ext>'.
    if (restrict.length > 0)
      this.fInput.setAttribute(
        "accept",
        restrict
          .map(function (ext) {
            return "." + ext;
          })
          .join(",")
      );
    this.fInput.click();
  }

  AllowMultipleFileUploads(allow = false) {
    var i = document.getElementById("selectfile");
    if (allow) {
      this.fInput.setAttribute("multiple", "true");
    } else {
      this.fInput.removeAttribute("multiple");
    }
  }

  DoUploadDrop(curOrg, curUser, curDir, files, restrictArray, dropTarget, allowMultiUpload) {
    var i = document.getElementById("selectfile");
    i.files = files;
    i.dropTarget = dropTarget;
    this.fInput["active"] = false;
    this.fInput["curorg"] = curOrg;
    this.fInput["curuser"] = curUser;
    this.fInput["files"] = files;
    this.fInput["curdir"] = curDir;
    this.fInput["restrict"] = restrictArray;
    this.AllowMultipleFileUploads(allowMultiUpload);

    return DoUploadFile();
  }

  IsBusy() {
    return this.fInput.value != "";
  }

  DoDownloadFile(curOrg, user, curDir, filename) {
    var rfc = new QOneUse();
    rfc.InitOneUse(this, false);
    rfc.SetParams(curOrg, user, curDir, filename);
    Globals._rfcMgr.QueueRFC(rfc);
  }

  BuildDownloadURL(baseURL, curOrg, user, curDir, filename, crcx, previewToken) {
    const apiServer = Globals._accountInfo.GetAPIServer();
    const encodeFilename = encodeURIComponent(filename);
    const encodeDir = encodeURIComponent(curDir);

    let theURL =
      baseURL +
      "?org=" +
      curOrg +
      "&dir=" +
      encodeDir +
      "&filename=" +
      encodeFilename +
      "&user=" +
      user +
      "&iv=" +
      crcx;

    if (previewToken) {
      theURL += "&pdt=" + encodeURIComponent(previewToken);
    }

    theURL += getsessioninfo();
    if (apiServer != null) {
      theURL = apiServer + theURL;
    }

    return theURL;
  }

  DoDownloadResult(baseURL, curOrg, user, curDir, filename, crcx, pubDownload, previewToken) {
    window.location.assign(
      this.BuildDownloadURL(baseURL, curOrg, user, curDir, filename, crcx, previewToken)
    );
  }

  CheckFileExists(org, user, dir, data) {
    var rfc = new QFileExists();
    rfc.InitFileExists(this);
    rfc.SetParams(org, user, dir, data);
    Globals._rfcMgr.QueueRFC(rfc);
  }

  ExecuteAlertCommand(aCmd) {
    var theCode = aCmd.GetCmdCode();
    var handled = true;

    switch (theCode) {
      case "OKUploadFile":
        this.FinishUpload(true);
        break;
      case "CnclUploadFile":
        var i = document.getElementById("selectfile");
        var dropTarget = i.dropTarget;
        var msg = "";
        var fileInfo = "";
        this.fCallBack.UploadFileComplete(msg, fileInfo, enumUploadCode.cancel, dropTarget);
        i.value = "";
        break;
      default:
        handled = false;
        break;
    }
    return handled;
  }

  UploadFailed(message, fileName, statusCode) {
    var w = this.fWSMgr;
    if (fileName != null) {
      var err = this.GetFileUploadMessage(fileName, statusCode);
      if (err.length > 0) message = message + " " + err;
    }
    w.DoAlertAsync(message, "");
  }

  GetFileUploadMessage(fileName, statusCode) {
    var w = this.fWSMgr;
    var fileMgr = w.fFileMgr;
    var s = "";
    var details = "";
    if (fileName != null) {
      var codeStr;
      s = '"' + fileName + '" ';
      switch (statusCode) {
        case enumUploadCode.success:
          codeStr = "successupload";
          break;
        case enumUploadCode.cancel:
          s = "";
          codeStr = "uploadcncl";
          break;
        case enumUploadCode.err:
        case enumUploadCode.invalidtype:
        default:
          codeStr = "uploadfail";
          break;
        case enumUploadCode.successr:
          codeStr = "successrupload";
          break;
        case enumUploadCode.maxsize:
          codeStr = "uploadfailtoobig";
          break;
        /*
        case enumUploadCode.invalidtype:
          if (!fileMgr || (fileMgr && fileMgr.fMode != enumFileMgrMode.upload))
          {
            s = '\n';
            codeStr = 'restrictedfiletypeupload';
          }
          else
          {
             return '';
          }
          break;
          */
      }
      s = s + appstr(codeStr) + " " + details;
    }

    //   this.fMessage.SetLabel(s);
    //  this.fMessage.AutoSize();

    return s;
  }

  FileExistsComplete(result) {
    var wsMgr = this.fWSMgr;
    var r = JSON.parse(result);

    if (r == "failure") {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), "Failed To Upload. Check User Privelages", this, wsMgr);
      wsMgr.EndProgress();
      wsMgr.PrepRenderWS();
      wsMgr.RenderWS();
      return;
    }

    if (r["conflictFiles"].length > 0) {
      var conflictCount = r["conflictFiles"].length;
      var clearCount = r["clearFiles"].length;
      var fileConflictAlertString;
      var isSingleConflict = conflictCount === 1;
      // There is no condition where conflictcount and newfilescount will both be 0.
      // There is no condition where conflictcount will be 0
      if (conflictCount > 0 && clearCount === 0) {
        // Only conflicts
        fileConflictAlertString = isSingleConflict
          ? appstr("replacefilenonew")
          : appstr("replacefilesnonew");
      } else {
        // Both conflicts and new files
        fileConflictAlertString = isSingleConflict ? appstr("replacefile") : appstr("replacefiles");
      }

      var i = document.getElementById("selectfile");
      var curDir = i["curdir"];
      if (curDir === "Masters") curDir = appstr("Backgrounds");
      fileConflictAlertString +=
        " \n" +
        appstrp("Directory", ": ") +
        curDir +
        ", " +
        appstrp("Duplicate file or files", ": ") +
        r["conflictFiles"].join(", ");

      var overwriteButtonString = isSingleConflict
        ? appstr("Replace Existing File")
        : appstr("Replace Existing Files");
      var cancelOverwriteButtonString = appstr("Cancel");

      var isSingleNewFile = clearCount === 0;
      var noCode = isSingleNewFile ? "CnclUploadFile" : "DiscardAll";

      var uploadCountStatus = "";
      if (clearCount > 0) {
        cancelOverwriteButtonString = isSingleConflict
          ? appstr("Skip Duplicate")
          : appstr("Skip Duplicates");
        uploadCountStatus += clearCount + " " + appstr("New");
      }
      uploadCountStatus +=
        (clearCount === 0 ? "" : ", ") + conflictCount + " " + appstr("Existing");

      fileConflictAlertString += "\n\n (" + uploadCountStatus + ")";

      var w = new QFileExistsAlert();
      w.InitConfirmAlert(
        appstr("Replace or Discard Files"),
        fileConflictAlertString,
        this,
        wsMgr,
        "OKUploadFile",
        noCode,
        overwriteButtonString,
        cancelOverwriteButtonString
      );

      w.fConflicts = r["conflictFiles"];
      wsMgr.EndProgress();
      wsMgr.PrepRenderWS();
      wsMgr.RenderWS();
    } else {
      this.FinishUpload(false);
    }
  }

  FinishUpload(doReplace, skipSaveList = []) {
    Globals._wsMgr.DoProgress(appstr("uploadingnow"));
    var i = document.getElementById("selectfile");
    var org = document.getElementById("curorg");
    org.value = i["curorg"];

    var user = document.getElementById("curuser");
    user.value = i["curuser"];

    var dir = document.getElementById("curdir");
    dir.value = i["curdir"];
    var f = document.getElementById("uploadform");

    var sk = document.getElementById("sk");
    sk.value = Globals._sessionKey;

    var paramsObj = {};
    paramsObj["skipFiles"] = skipSaveList;

    var params = document.getElementById("params");
    params.value = JSON.stringify(paramsObj);

    var curFileList = i["filenames"].slice(0);
    if (skipSaveList.length > 0) {
      i["filenames"] = curFileList.filter(function (item) {
        return !skipSaveList.includes(item);
      });
    }

    i["files"] = removeFilesByName(i["files"], skipSaveList);

    // Don't think these are getting used at all
    i["active"] = true;
    i["doreplace"] = doReplace;

    f.submit();
  }

  DoDownloadPublish(curOrg, user, filename) {
    var curDir = "Preview";

    var rfc = new QOneUse();
    rfc.InitOneUse(this, true);
    rfc.SetParams(curOrg, user, curDir, filename);
    Globals._rfcMgr.QueueRFC(rfc);
    this.fWSMgr.fBackgroundPanel.SetHasVertScrollBar(false);
  }
}
